import { RG_TYPE } from '../../types/rg-type.js';
import { DefaultApartment } from './default-apartment.js';
import { DefaultBalcony } from './default-balcony.js';
import { DefaultBeam } from './default-beam.js';
import { DefaultBuilding } from './default-building.js';
import { DefaultCeiling } from './default-ceiling.js';
import { DefaultColumn } from './default-column.js';
import { DefaultCore } from './default-core.js';
import { DefaultCorridor } from './default-corridor.js';
import { DefaultDoor } from './default-door.js';
import { DefaultEmptySpace } from './default-empty-space.js';
import { DefaultEntrance } from './default-entrance.js';
import { DefaultFacade } from './default-facade.js';
import { DefaultFloor } from './default-floor.js';
import { DefaultGlazing } from './default-glazing.js';
import { DefaultModule } from './default-module.js';
import { DefaultOpening } from './default-opening.js';
import { DefaultParapet } from './default-parapet.js';
import { DefaultPlot } from './default-plot.js';
import { DefaultRoof } from './default-roof.js';
import { DefaultRoom } from './default-room.js';
import { DefaultSite } from './default-site.js';
import { DefaultTechnicalSpace } from './default-technical-space.js';
import { DefaultTechnicalSpaceRoom } from './default-technical-space-room.js';
import { DefaultWall } from './default-wall.js';
import { DefaultWindow } from './default-window.js';
import { DefaultWorld } from './default-world.js';
import { DefaultZone } from './default-zone.js';

const RgDefaults = {
    [RG_TYPE.World]: DefaultWorld,
    [RG_TYPE.Site]: DefaultSite,
    [RG_TYPE.Zone]: DefaultZone,
    [RG_TYPE.Plot]: DefaultPlot,
    [RG_TYPE.Building]: DefaultBuilding,
    [RG_TYPE.Core]: DefaultCore,
    [RG_TYPE.Entrance]: DefaultEntrance,
    [RG_TYPE.Corridor]: DefaultCorridor,
    [RG_TYPE.TechnicalSpace]: DefaultTechnicalSpace,
    [RG_TYPE.TechnicalSpaceRoom]: DefaultTechnicalSpaceRoom,
    [RG_TYPE.Apartment]: DefaultApartment,
    [RG_TYPE.Module]: DefaultModule,
    [RG_TYPE.Balcony]: DefaultBalcony,
    [RG_TYPE.Wall]: DefaultWall,
    [RG_TYPE.Floor]: DefaultFloor,
    [RG_TYPE.Roof]: DefaultRoof,
    [RG_TYPE.Ceiling]: DefaultCeiling,
    [RG_TYPE.Door]: DefaultDoor,
    [RG_TYPE.Column]: DefaultColumn,
    [RG_TYPE.Beam]: DefaultBeam,
    [RG_TYPE.Window]: DefaultWindow,
    [RG_TYPE.Facade]: DefaultFacade,
    [RG_TYPE.Room]: DefaultRoom,
    [RG_TYPE.Opening]: DefaultOpening,
    [RG_TYPE.Parapet]: DefaultParapet,
    [RG_TYPE.EmptySpace]: DefaultEmptySpace,
    [RG_TYPE.Glazing]: DefaultGlazing
};

export { RgDefaults };
//# sourceMappingURL=rg-defaults.js.map
